import type { ComicPanel } from './comicTypes'

/** 仅用于旧数据：从「台词」单字段拆到旁白（不含心声、内心独白） */
const NARRATION_MIGRATE_LEAD_RE =
  /^(?:[（(【[]?\s*(?:旁白|叙述|解说|画外音|Narration|NARRATION)\s*[）)】\]]?\s*[:：\-—]?\s*)+/iu

/** 心声、OS 等：仍在台词字段，生图时用思绪气泡 */
const THOUGHT_LEAD_RE =
  /^(?:[（(【[]?\s*(?:心声|内心(?:独白)?|独白|OS|思考|心里想)\s*[）)】\]]?\s*[:：\-—]?\s*)+/iu

/** 剥除所有可识别的类型标签（可连续多层，如「（心声）（旁白）」） */
const META_LABEL_STRIP_RE =
  /^(?:[（(【[]?\s*(?:旁白|叙述|解说|画外音|心声|内心(?:独白)?|独白|OS|思考|心里想|Narration|NARRATION)\s*[）)】\]]?\s*[:：\-—]?\s*)+/iu

export function stripDialogueMetaLabels(raw: string): string {
  let s = raw.trim()
  if (!s) return ''
  let prev = ''
  while (s !== prev) {
    prev = s
    const m = s.match(META_LABEL_STRIP_RE)
    if (!m) break
    s = s.slice(m[0].length).trim()
  }
  return s
}

export function classifySpeechField(dialogue: string): { kind: 'speech' | 'thought'; text: string } {
  const trimmed = dialogue.trim()
  if (!trimmed) return { kind: 'speech', text: '' }
  if (THOUGHT_LEAD_RE.test(trimmed)) {
    return { kind: 'thought', text: stripDialogueMetaLabels(trimmed) }
  }
  return { kind: 'speech', text: stripDialogueMetaLabels(trimmed) }
}

/** 旧数据：仅「旁白/叙述」类前缀迁入 narration；心声留在台词并由 classifySpeechField 处理 */
export function migratePanelDialogueFields(panel: ComicPanel): ComicPanel {
  const narration = (panel.narration ?? '').trim()
  const dialogue = panel.dialogue.trim()
  if (narration || !dialogue) {
    return {
      ...panel,
      narration: stripDialogueMetaLabels(panel.narration ?? ''),
      dialogue: stripDialogueMetaLabels(dialogue),
    }
  }
  if (THOUGHT_LEAD_RE.test(dialogue)) {
    return {
      ...panel,
      narration: panel.narration ?? '',
      dialogue: stripDialogueMetaLabels(dialogue),
    }
  }
  const lead = dialogue.match(NARRATION_MIGRATE_LEAD_RE)
  if (!lead) {
    return {
      ...panel,
      narration: stripDialogueMetaLabels(panel.narration ?? ''),
      dialogue: stripDialogueMetaLabels(dialogue),
    }
  }
  const body = stripDialogueMetaLabels(dialogue.slice(lead[0].length))
  if (!body) return panel
  return { ...panel, dialogue: '', narration: body }
}

export function panelHasOverlayText(panel: ComicPanel): boolean {
  const lines = panel.characterLines ?? []
  if (lines.some((l) => (l.speech ?? '').trim() || (l.thought ?? '').trim() || (l.dialogue ?? '').trim())) {
    return true
  }
  return Boolean(panel.dialogue.trim() || (panel.narration ?? '').trim())
}

export function panelSpeechOverlayKind(panel: ComicPanel): 'speech' | 'thought' {
  return classifySpeechField(panel.dialogue).kind
}

export function panelSpeechOverlayText(panel: ComicPanel): string {
  return classifySpeechField(panel.dialogue).text
}
